export default __webpack_public_path__ + "locales/bg/Notifications.json?hash=3d56dcaf74ed456165c94e8444252502";